import { useEffect, useState } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

const TEST_NAME = 'PDP_ReturnsV3_April2025';

export const usePdpReturnsClientVariant = (): boolean | null => {
    const [isVariant, setVariant] = useState<boolean | null>(null);

    useEffect(() => {
        setVariant(getAbTestV2(TEST_NAME)?.variant === 'variant');
    }, []);

    return isVariant;
};

export const useTrackPdpReturns = (): void => {
    useEffect(() => {
        trackAbTestV2Variant(TEST_NAME);
    }, []);
};
